var _this = this;

import { getPerformanceGraph } from '../generated';
export var getWorkoutPerformanceGraphWithHasAppleWatchMetrics = function getWorkoutPerformanceGraphWithHasAppleWatchMetrics(api, _ref) {
  var workoutId = _ref.workoutId,
      everyN = _ref.everyN,
      maxGapMeters = _ref.maxGapMeters,
      includeOutput = _ref.includeOutput,
      durationSummaryInSeconds = _ref.durationSummaryInSeconds,
      acceptLanguage = _ref.acceptLanguage,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return getPerformanceGraph.apply(_this, [api, workoutId, everyN, maxGapMeters, includeOutput, durationSummaryInSeconds, acceptLanguage, options]);
};